export const normalizeWebSocketUrl = (value) =>
  String(value || "").replace(/\/+$/, "");

export const webSocketUrl = normalizeWebSocketUrl(
  import.meta.env.VITE_WEB_SOCKET_ENDPOINT,
);
